import tableMainhubConfig from './tableMainhubConfig';

export default {
  title: 'Configuration Management',
  attributeName: 'mainHubConfig',
  getURL: 'mainHubs/mainHubId/mainHubConfigs',
  createURL: 'mainHubs/mainHubId/mainHubConfigs',
  updateURL: 'mainHubs/mainHubId/mainHubConfigs',
  removeURL: 'mainHubs/mainHubId/mainHubConfigs',
  removeTitle:'Confirm Implications',
  removeText:'You are about to delete the ##name## config. This action will have the following effects:\n\n1. Personal data removal\n ---- Region code, language and devices associated with this config will be permanently erased.\n\n 2. Content and personalization deletion\n ---- Any unique canvas, content, or categories tied to this config will be removed from the app.\n ---- All personalized settings, such as regional content or feature testing configurations, will be deleted.',
  removeNameField:'name',
  buttonOkText:'Confirm',
  removeReconfirmMessage:'Are you sure you want to proceed the deletion? You will delete the following elements:',
  removeReconfirmURL:'mainHubs/mainHubId/deleteConfirmMainHubConfigs',
  sessionParams: ['mainHubId'],
  tableConfig: tableMainhubConfig,
  noArea: true,
  autoUpdate: true,
  revalidate: true,
};
